import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import TimelineFeed from "@/pages/home/components/TimelineFeed";
import GalleryGrid from "@/pages/home/components/GalleryGrid";
import VideoShowcase from "@/pages/home/components/VideoShowcase";
import TrustFaq from "@/pages/home/components/TrustFaq";
import Subscribe from "@/pages/home/components/Subscribe";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 overflow-x-hidden">
      <Navbar />
      <main className="w-full">
        <Hero />
        <CategoryGrid />
        <TimelineFeed />
        <GalleryGrid />
        <VideoShowcase />
        <TrustFaq />
        <Subscribe />
      </main>
      <Footer />
    </div>
  );
}